import React from 'react';
import PropTypes from 'prop-types';
import {
  BsFacebook,
  BsInstagram,
  BsYoutube,
  BsPinterest,
  BsTiktok,
} from 'react-icons/bs';
import { FaXTwitter } from 'react-icons/fa6';
import { Flex, VStack } from '@chakra-ui/react';

import Link from '@rsc/ui-components/tailwind/Link';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

function SocialButton({ href, label, icon }) {
  return (
    <VStack
      aria-label={label}
      as={Link}
      link={{ blank: true, href, linkType: 'external' }}
    >
      <Flex
        transition="all 0.2s ease-in-out"
        bg="secondary.base"
        _hover={{ bg: 'secondary.hover' }}
        borderRadius="lg"
        width={12}
        height={12}
        alignItems="center"
        justifyContent="center"
        color="typography.lighter"
      >
        {icon}
      </Flex>
    </VStack>
  );
}

SocialButton.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
};

function SocialIcons({ footerSocialIcons }) {
  const { tt } = useUiComponentsInternationalContext();

  return (
    <Flex
      gap={2}
      justifyContent={['space-between', null, 'flex-start']}
      mb={[10, null, 14]}
    >
      {footerSocialIcons?.instagramBool && (
        <SocialButton
          label={tt(s => s.socialIconsComponent.instagramButton)}
          href={footerSocialIcons.instagramUrl}
          icon={<BsInstagram size="24px" />}
        />
      )}

      {footerSocialIcons?.facebookBool && (
        <SocialButton
          label={tt(s => s.socialIconsComponent.facebookButton)}
          href={footerSocialIcons.facebookUrl}
          icon={<BsFacebook size="24px" />}
        />
      )}

      {footerSocialIcons?.twitterBool && (
        <SocialButton
          label={tt(s => s.socialIconsComponent.xSocialMediaButton)}
          href={footerSocialIcons.twitterUrl}
          icon={<FaXTwitter size="24px" />}
        />
      )}

      {footerSocialIcons?.pinterestBool && (
        <SocialButton
          label={tt(s => s.socialIconsComponent.pinterestButton)}
          href={footerSocialIcons.pinterestUrl}
          icon={<BsPinterest size="24px" />}
        />
      )}

      {footerSocialIcons?.youtubeBool && (
        <SocialButton
          label={tt(s => s.socialIconsComponent.youTubeButton)}
          href={footerSocialIcons.youtubeUrl}
          icon={<BsYoutube size="24px" />}
        />
      )}

      {footerSocialIcons?.tiktokBool && (
        <SocialButton
          label={tt(s => s.socialIconsComponent.tikTokButton)}
          href={footerSocialIcons.tiktokUrl}
          icon={<BsTiktok size="24px" />}
        />
      )}
    </Flex>
  );
}

SocialIcons.propTypes = {
  footerSocialIcons: PropTypes.shape({
    facebookBool: PropTypes.bool,
    facebookUrl: PropTypes.string,
    instagramBool: PropTypes.bool,
    instagramUrl: PropTypes.string,
    youtubeBool: PropTypes.bool,
    youtubeUrl: PropTypes.string,
    twitterBool: PropTypes.bool,
    twitterUrl: PropTypes.string,
    pinterestBool: PropTypes.bool,
    pinterestUrl: PropTypes.string,
    tiktokBool: PropTypes.bool,
    tiktokUrl: PropTypes.string,
  }).isRequired,
};

export default SocialIcons;
